/* eslint-disable */
"use strict";

const Config = require('./config');
const _ = require('lodash');
const moment = require('moment');
import {PhoneNumberUtil} from 'google-libphonenumber';

let _qqGirlHidden = false;

let scriptPrefix = null;

// const percentageRegex = /^100(\.00?)?$|^([1-9]?\d)(\.\d{1,2})?$/; // onBlur
const percentageRegex = /^100(\.0{0,4})?$|^([1-9]?\d?)(\.\d{0,4})?$/;
const numbersRegex = /^([1-9]\d{0,3})(\.\d{0,2})?$|^0(\.\d{0,2})?$/;

module.exports = {
  layerBgUrl: function (imageUrl) {
    imageUrl = encodeURI(imageUrl).replace(new RegExp('#', 'g'), '%23');
    return this.bgImageUrl(Config.AmazonS3.root + imageUrl + '_' + Config.layerSize() + '.png');
  },
  imgSrc: function (imageUrl) {
    return Config.AmazonS3.root + imageUrl + '_' + Config.layerSize() + '.png';
  },
  bgImageUrl: function (imageUrl) {
    return `url(${imageUrl})`;
  },

  contentImage(imageUrl) {
    return `/images/${imageUrl}`;
  },
  contentBgImageUrl(imageUrl){
    return this.bgImageUrl(this.contentImage(imageUrl));
  },
  hostedImageUrl(imageUrl) {
    if (document.kvConfig.apiUrl && document.kvConfig.apiUrl.includes('gfd.us') || document.location.port === '9005')
      return imageUrl;
    return '/content/views/dashboard/' + imageUrl;
  },

  /**
   * Replaces all occurrences of a string with another
   * @param str
   * @param search
   * @param replacement
   */
  replaceAll: function(str, search, replacement) {
    return str.replace(new RegExp(search, 'g'), replacement);
  },

  replaceLeftSpaces: function (str, replacement) {
      let res = '';
      let i = 0;
      for (; str[i] === ' ' && i < str.length; i++)
        res += replacement;
      if (i !== str.length)
        res += str.substr(i);
      return res;
  },

  toNumber: function (value, defaultValue = 0) {
    const number = parseFloat(value);
    return isNaN(number) ? defaultValue : number
  },

  isValidPercent: function (value) {
    return percentageRegex.test(value)
  },

  validateNumberValue: function (value, maxValue) {
    if (value === "") {
      return true;
    }
    if (!numbersRegex.test(value)) {
      return false
    }
    // Convert value to a float and compare with maxValue
    const numValue = parseFloat(value);
    // If the value is a valid number and not exceeding the max value, allow it
    return isNaN(numValue) || numValue <= maxValue;
  },


  /**
   * @param {number} num
   * @param {number} percent
   * @returns {number}
   */
  percentage: function (num, percent) {
    return (num / 100) * percent;
  },

  /**
   *
   * @param {int} hour
   * @returns {string}
   */
  toHourString: function (hour) {
    return (hour === 12 ? (hour + ':00 PM') : (hour < 12) ? (hour + ':00 AM') : ((hour - 12) + ':00 PM'));
  },
  /**
   * Get the script-qualified path to an asset.
   * @param {string} path
   * @returns {string}
   */
  scriptPath: function (path) {
    if (scriptPrefix === null) {
      let scripts = document.getElementsByTagName('script'),
        script = scripts[scripts.length - 1],
        scriptPath;

      if (script.getAttribute.length !== undefined) {
        scriptPath = script.getAttribute('src');
      } else {
        scriptPath = script.getAttribute('src', 2);
      }

      scriptPrefix = scriptPath && scriptPath.lastIndexOf('/') !== -1 ? this.pathPrefix(scriptPath) : '';
    }

    return scriptPrefix + ((path !== undefined) ? '/' + path : '');
  },

  splitFilter: function (filter) {
    const res = {};
    _.forEach(filter.split('&'), function (pair) {
      const ar = pair.split('=');
      res[ar[0]] = ar[1];
    });
    return res;
  },

  /**
   * Makes a case-insensitive string compare
   * @param s1 {string}
   * @param s2 {string}
   * @returns {boolean}
   */
  iCmp: function (s1, s2) {
    if (!s1 && !s2) {
      return true;
    }
    if (!s1 || !s2) {
      return false;
    }

    return s1.toUpperCase() === s2.toUpperCase();
  },
  keysAndProps: function (obj) {
    const res = _.keys(obj);
    console.log(res);
    for (let key in res) {
      const prop = obj[key];
      if (Array.isArray(prop)) {
        res.push(prop);
      }
    }

    return res;
  },
  isObject: function (val) {
    if (val === null) {
      return false;
    }
    return ( (typeof val === 'function') || (typeof val === 'object') );
  },

  /**
   * return the path without last part which is supposelly the file name
   * @param {string} path
   * @param {int} [count=1]
   */
  pathPrefix: function (path, count) {
    count = count || 1;
    while (count-- > 0) {
      const index = path.lastIndexOf("/");
      if (index === -1) {
        return path;
      }

      path = path.substr(0, index);
    }

    return path;
  },

  /**
   * Converts a string to a boolean value
   * @param value
   */
  toBoolean: function (value) {
    if (typeof (value) === 'string') {
      value = value.toLowerCase();
    }
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  },

  /**
   * Cast a string into a `moment` instance using a predefined format
   * @param str {string}
   */
  toMoment: function (str) {
    return moment(str, 'YYYY-MM-DDTHH:mm:ss.SSS');
  },

  /**
   * Cuts text to a given length if text is longer than specified and appends it with ...
   * @param str {string}
   * @param neededLength {int}
   */
  cutText: function (str, neededLength = 20) {
    if (!str || str.length < neededLength) {
      return str;
    }

    return str.substr(0, neededLength) + '...';
  },

  convertKeysToCamelCase: function (obj) {
    if (!obj || typeof obj !== "object") {
      return null;
    }

    if (obj instanceof Array) {
      return $.map(obj, function (value) {
        return this.convertKeysToCamelCase(value);
      });
    }

    const newObj = {};
    $.each(obj, function (key, value) {
      key = key.charAt(0).toLowerCase() + key.slice(1);
      newObj[key] = value;
    });

    return newObj;
  },
  toCamel: function (o) {
    let build, key, destKey, value;

    if (o instanceof Array) {
      build = [];
      for (key in o) {
        value = o[key];

        if (typeof value === "object") {
          value = this.toCamel(value);
        }
        build.push(value);
      }
    } else {
      build = {};
      for (key in o) {
        if (o.hasOwnProperty(key)) {
          destKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString();
          value = o[key];
          if (value !== null && typeof value === "object") {
            value = this.toCamel(value);
          }

          build[destKey] = value;
        }
      }
    }
    return build;
  },
  ignoreDefault: function (e) {
    if(e.preventDefault && e.stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }
  },

  toCamelCase: function (s) {
    return s.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  toTitleCase: function(str)
  {
      return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  },
  toColor: function (num) {
    num >>>= 0;
    const b = num & 0xFF,
      g = (num & 0xFF00) >>> 8,
      r = (num & 0xFF0000) >>> 16,
      a = ( (num & 0xFF000000) >>> 24 ) / 255;
    return "rgba(" + [r, g, b, a].join(",") + ")";
  },
  formatPhone: function (phone) {
    if (!phone) {
      return '';
    }

    let p = phone.replace(/[\(|\)]/g, '').replace(/[\s\-]/g, '.');
    if (p.indexOf('.') === -1) {
      const m = p.match(/^(\d{3})(\d{3})(\d{1,4})$/);
      if (m) {
        p = `${m[1]}.${m[2]}.${m[3]}`;
      }
    }

    return p;
  },
  getClickPosition: function (el) {
    let xPosition = 0;
    let yPosition = 0;

    while (el) {
      if (el.tagName === "BODY") {
        // deal with browser quirks with body/window/document and page scroll
        const xScrollPos = el.scrollLeft || document.documentElement.scrollLeft;
        const yScrollPos = el.scrollTop || document.documentElement.scrollTop;

        xPosition += (el.offsetLeft - xScrollPos + el.clientLeft);
        yPosition += (el.offsetTop - yScrollPos + el.clientTop);
      } else {
        xPosition += (el.offsetLeft - el.scrollLeft + el.clientLeft);
        yPosition += (el.offsetTop - el.scrollTop + el.clientTop);
      }

      el = el.offsetParent;
    }
    return {
      x: xPosition,
      y: yPosition
    };
  },

  hideQQGirl: function () {
    if (document.kvConfig.kioskMode && !_qqGirlHidden) {
      _qqGirlHidden = true;
      window.parent.$(window.parent.document).trigger('hide-qq-girl');
    }
  },

  /**
   * Checked whether a moment object has a zero date
   * @param d {moment}
   */
  isDateZero: function (d) {
    return d.year() === 0;
  },

  arrayMove: function (array, oldIndex, newIndex) {
    while (oldIndex < 0) {
      oldIndex += array.length;
    }
    while (newIndex < 0) {
      newIndex += array.length;
    }
    if (newIndex >= array.length) {
      let k = newIndex - array.length;
      while ((k--) + 1) {
        array.push(undefined);
      }
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    return array; // for testing purposes
  },
  extractDomain: function (url) {
    let domain;
    let protocol = null;
    let subDomain = null;
    //find & remove protocol (http, ftp, etc.) and get domain
    if (url.indexOf("://") > -1) {
      const ar = url.split('/');

      domain = ar[2];
      protocol = ar[0].slice(0, -1);
    }
    else {
      domain = url.split('/')[0];
    }

    //find & remove port number
    domain = domain.split(':')[0];

    const domainParts = domain.split('.');
    if (domainParts.length === 3){
      subDomain = domainParts[0];
    }

    return {domain, protocol, subDomain};
  },
  monads: {
    ifNotNull: function (o, notNullCallback) {
      if (o) {
        return notNullCallback(o);
      }

      return null;
    },
    /**
     *
     * @param o {object}
     * @param func {function} attribute extractor
     * @param defaultValue {object} default value in case object is Null
     * @return {*}
     * @constructor
     */
    NN: function (o, func, defaultValue) {
      return o ? func(o) : defaultValue;
    }
  },
  detectCardType: function(cardNumber) {
    if(/^4[0-9]{12}(?:[0-9]{3})?$/.test(cardNumber)) return "visa";
    if(/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(cardNumber)) return "discover";
    if(/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(cardNumber)) return "mastercard";
    if(/^3[47][0-9]{13}$/.test(cardNumber)) return "amex";
    if(/^(?:2131|1800|35\d{3})\d{11}$/.test(cardNumber)) return "jcb";
    if(/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(cardNumber)) return "diners";
    if(/^62[0-9]{14}[0-9]*$/.test(cardNumber)
      || /^81[0-9]{14}[0-9]*$/.test(cardNumber) || /^62\\d{0,14}/.test(cardNumber)) return "unionPay";
    return null;
  },
  validateCCInfo: function({name, number, expYear, expMonth, cvv}) {
    let errors = [];
    if (!name || !_.trim(name).length) {
      errors.push("Please enter the Name on Card");
    }
    const ccType = this.detectCardType(number);
    let cvvLength = 3;
    if (!ccType) {
      errors.push("Please enter a valid Credit Card Number");
    }
    if (ccType === 'amex') {
      cvvLength = 4;
    }
    if (!/\d{2}/.test(expMonth)) {
      errors.push("Please enter 2-digit Expiration month.  For Example: 01, 02, 10, etc");
    }
    if (!/\d{2}/.test(expYear) && !/\d{4}/.test(expYear)) {
      errors.push("Please enter last 2 digits or full year of the Expiration year.  For Example: 09, 19, 29, 2018, 2022 etc");
    }
    expMonth = +expMonth;
    if (expMonth < 1 || expMonth > 12) {
      errors.push('Month must be a number between 1 and 12.')
    }
    expYear = +expYear;
    if (expYear > 2100) {
      errors.push("Year must not be greater than 2100.");
    }
    if (expYear > 99)
      expYear -= 2000; // well, assuming only 2000 year :)
    if ((2000 + expYear < (new Date()).getFullYear()) ||
      (2000 + expYear === (new Date()).getFullYear() && +expMonth < ((new Date()).getMonth() + 1))
    ) {
      errors.push("Credit Card Expiration Date has expired.");
    }
    if (!cvv || _.trim(cvv).length !== cvvLength) {
      errors.push(`CVV/CVC does not appear valid, it must be ${cvvLength} numbers only.`);
    } else if(cvv && !/[0-9]{3,4}/g.test(cvv)) {
      errors.push(`CVV/CVC does not appear valid, it must be ${cvvLength} numbers only.`);
    }
    return errors;
  },
  parseQuery: function(queryString = null) {
    queryString = queryString || window.location.search;
    const query = {};
    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0]).toLowerCase()] = decodeURIComponent(pair[1] || '');
    }
    return query;
  },
  isZip: function (zip) {
    const regex = /[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]/;
    return regex.test(zip);
  },
  isPhoneNumber: function (phone) {
    const phoneUtil = PhoneNumberUtil.getInstance();
    if(phone.indexOf('555-555-5555') >= 0)
      return true;
    try {
      return phone && phoneUtil.isValidNumber(phoneUtil.parse(phone)); // /^\+?\d{10,16}$/.test(phone);
    } catch(ex) {
      return false;
    }
  },
  /**
   * Returns the last 4 characters of a string
   * @param {string} cardNumber
   * @return {*}
   */
  last4: (cardNumber) => {
    if (!cardNumber || cardNumber.length < 5)
      return cardNumber;
    return cardNumber.slice(cardNumber.length - 4, cardNumber.length);
  },
  capitalizeFirstLetter: (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  isMobile: (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
};

